(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('ps-js');

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-ps-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initRails(scope) {
    (scope || document).querySelectorAll('[data-ps-rail]').forEach(function (wrap) {
      if (wrap.dataset.psReady) return;
      wrap.dataset.psReady = '1';
      var rail = wrap.querySelector('.ps-rail');
      wrap.querySelectorAll('[data-ps-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = rail.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 12 : 300;
          rail.scrollBy({ left: step * Number(btn.dataset.psDir), behavior: 'smooth' });
        });
      });
    });
  }

  function refreshCartBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        bubble.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form.matches || !form.matches('[data-ps-add]')) return;
    ev.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.textContent = 'Agregado ✓';
        refreshCartBubble();
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
      })
      .catch(function () { form.removeAttribute('data-ps-add'); form.submit(); });
  });

  var productsCache = null;
  function loadProducts(handle) {
    if (productsCache) return Promise.resolve(productsCache);
    var all = [];
    function page(n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var list = (d && d.products) || [];
          all = all.concat(list);
          if (list.length === 250 && n < 4) return page(n + 1);
          productsCache = all;
          return all;
        });
    }
    return page(1);
  }

  function money(v) {
    return '$' + Number(v).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function initFinder(scope) {
    (scope || document).querySelectorAll('[data-ps-finder]').forEach(function (form) {
      if (form.dataset.psReady) return;
      form.dataset.psReady = '1';
      var out = form.querySelector('[data-ps-results]');
      var list = form.querySelector('[data-ps-list]');
      var msg = form.querySelector('[data-ps-msg]');
      var more = form.querySelector('[data-ps-more]');
      var handle = form.dataset.collection || 'palas';

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var fd = new FormData(form);
        var level = fd.get('nivel');
        var style = fd.get('estilo');
        var budget = String(fd.get('presupuesto') || '0-999999').split('-');
        var min = Number(budget[0]);
        var max = Number(budget[1]);
        var btn = form.querySelector('button[type=submit]');
        btn.disabled = true;
        out.hidden = false;
        msg.textContent = 'Buscando las palas ideales para ti…';
        list.innerHTML = '';

        loadProducts(handle).then(function (products) {
          var scored = [];
          products.forEach(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0];
            if (!v) return;
            var price = Number(v.price);
            if (price < min || price > max) return;
            var tags = (p.tags || []).map(norm);
            var score = 0;
            if (level && tags.some(function (t) { return t.indexOf(norm(level)) > -1; })) score += 2;
            if (style && tags.some(function (t) { return t.indexOf(norm(style)) > -1; })) score += 2;
            var compare = Number(v.compare_at_price || 0);
            if (compare > price) score += 0.5;
            scored.push({ p: p, v: v, price: price, compare: compare, score: score });
          });
          scored.sort(function (a, b) { return b.score - a.score || b.price - a.price; });
          var top = scored.slice(0, 3);
          if (!top.length) {
            msg.textContent = 'No encontramos palas disponibles en ese rango hoy. Prueba otro presupuesto o escríbenos y te ayudamos a elegir.';
          } else {
            msg.textContent = 'Te recomendamos estas ' + top.length + ' palas disponibles:';
            list.innerHTML = top.map(function (x) {
              var img = x.p.images && x.p.images[0] ? x.p.images[0].src : '';
              return '<a class="ps-quiz__item" href="/products/' + x.p.handle + '">' +
                (img ? '<img src="' + imgUrl(img, 160) + '" alt="' + esc(x.p.title) + '" width="72" height="72" loading="lazy">' : '<span></span>') +
                '<span><strong>' + esc(x.p.title) + '</strong><em>' + money(x.price) + '</em>' +
                (x.compare > x.price ? '<s>' + money(x.compare) + '</s>' : '') + '</span></a>';
            }).join('');
          }
          more.href = '/collections/' + handle + '?filter.v.availability=1&filter.v.price.gte=' + min + (max < 999999 ? '&filter.v.price.lte=' + max : '');
          more.hidden = false;
        }).catch(function () {
          msg.textContent = 'No pudimos cargar las recomendaciones. Ve todas las palas aquí:';
          more.href = '/collections/' + handle;
          more.hidden = false;
        }).then(function () { btn.disabled = false; });
      });
    });
  }

  function init(scope) { initReveal(scope); initRails(scope); initFinder(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
